import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl, sharedValidators } from "../../lib/shared/validators";

export const branchStatus = v.union(v.literal("active"), v.literal("inactive"));
export const validatorBranch = v.object({
  // new fields (didn't exist in old version)
  name: v.string(), // Nombre de la empresa
  code: v.string(), // Código de la empresa
  correlativeCode: v.optional(v.string()), // Código fiscal de la empresa
  description: v.optional(v.string()), // Descripción de la empresa
  legalName: v.optional(v.string()), // Razón social completa
  taxId: v.optional(v.string()), // RTN o identificación fiscal
  email: v.optional(v.string()), // Email principal de la empresa
  phone: v.optional(v.string()), // Teléfono principal
  address: v.optional(v.string()), // Dirección física
  city: v.optional(v.string()), // Ciudad
  country: v.optional(v.string()), // País
  website: v.optional(v.string()), // Sitio web
  logoId: v.optional(v.id("_storage")), // Logo de la empresa
  companyId: v.optional(v.id("companies")),
  // Configuracion predeterminada de la sucursal
  defaultTaxRate: v.optional(v.number()), // Tasa de impuesto por defecto (%)
  defaultProfitMargin: v.optional(v.number()), // Margen de ganancia por defecto (%)
  defaultCurrency: v.optional(v.string()), // Moneda por defecto (HNL, USD, etc.)
  internalControl: internalControl,
});

export const branches = defineTable(validatorBranch)
  .index("by_code", ["code"])
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_company_and_code", ["internalControl.companyId", "code"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_state", ["internalControl.state"])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_branch_and_state", [
    "internalControl.branchId",
    "internalControl.state",
  ])
  .index("by_created_by", ["internalControl.createdBy"])
  .index("by_updated_by", ["internalControl.updatedBy"])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ]);
